(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["b2b-product-gallery"] && !Shopify.designMode) return;
  try {
    (function initB2BProductGallery() {
    const galleries = document.querySelectorAll('[data-b2b-product-gallery]');
    if (!galleries.length) return;

    galleries.forEach((gallery) => {
      if (gallery.dataset.b2bGalleryBound === 'true') return;
      gallery.dataset.b2bGalleryBound = 'true';

      const productRoot = gallery.closest('.b2b-product');
      const slides = gallery.querySelectorAll('[data-b2b-gallery-slide]');
      const thumbs = gallery.querySelectorAll('[data-b2b-gallery-thumb]');
      const variantMediaScript = gallery.querySelector('[data-b2b-variant-media]');

      if (!slides.length || !thumbs.length) return;

      let variantMedia = {};
      if (variantMediaScript) {
        try {
          variantMedia = JSON.parse(variantMediaScript.textContent || '{}');
        } catch {
          variantMedia = {};
        }
      }

      const pauseVideos = (container) => {
        container?.querySelectorAll('video').forEach((video) => {
          video.pause();
        });
      };

      const syncProductImage = (slide) => {
        if (!productRoot || !slide) return;
        const image = slide.querySelector('.b2b-product__image');
        if (image?.src) {
          productRoot.dataset.productImage = image.src;
        }
      };

      const activateMedia = (mediaId) => {
        if (!mediaId) return;

        let matched = false;
        slides.forEach((slide) => {
          const isMatch = String(slide.dataset.mediaId) === String(mediaId);
          slide.hidden = !isMatch;
          if (isMatch) {
            matched = true;
            syncProductImage(slide);
          } else {
            pauseVideos(slide);
          }
        });

        if (!matched) return;

        thumbs.forEach((thumb) => {
          const isActive = String(thumb.dataset.mediaId) === String(mediaId);
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          activateMedia(thumb.dataset.mediaId);
        });
      });

      if (productRoot && Object.keys(variantMedia).length > 0) {
        const observer = new MutationObserver(() => {
          const variantId = productRoot.dataset.variantId;
          const mediaId = variantMedia[String(variantId)];
          if (mediaId) activateMedia(mediaId);
        });
        observer.observe(productRoot, {
          attributes: true,
          attributeFilter: ['data-variant-id'],
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
